/* Exact branch positions, resolved from the company's own Google Maps share
   links (the same ones behind "Get Directions"). Order matches
   `translations[lang].locations.list`. Used by the map embed and by the
   LocalBusiness structured data. */
export const BRANCHES = [
  {
    id: "istanbul",
    lat: 41.0858302,
    lng: 28.7240739,
    street: "Şahintepe Mah., Lalezar Sk., 602. Cad.",
    locality: "Başakşehir, İstanbul",
    postalCode: "34494",
    country: "TR",
    phone: "+905521627900",
  },
  {
    id: "damascus-office",
    lat: 33.5045441,
    lng: 36.3141394,
    street: "Zablatani, Ibn Asaker",
    locality: "Damascus",
    country: "SY",
    phone: "+963945184737",
  },
  {
    id: "damascus-warehouse",
    lat: 33.602081,
    lng: 36.466339,
    street: "Old Aleppo Highway, after Tel Kurdi junction",
    locality: "Damascus",
    country: "SY",
    phone: "+963994705609",
  },
  {
    id: "aleppo",
    lat: 36.218471,
    lng: 37.237655,
    street: "Nuqarin",
    locality: "Aleppo",
    country: "SY",
    phone: "+963964355325",
  },
];

const MAP_LANG = { ar: "ar", en: "en", tr: "tr", "zh-CN": "zh-CN" };

/* Keyless Google Maps embed, pinned on the exact coordinates. */
export function mapEmbedUrl(branch, lang = "en") {
  return `https://maps.google.com/maps?q=${branch.lat},${branch.lng}&z=16&hl=${MAP_LANG[lang] || "en"}&output=embed`;
}
